import { cn } from "utils";

export const Separator = ({ className = "" }) => (
  <div className={cn("flex-1 border-[0.5px] border-[#eeeeee]", className)} />
);
